import { useEffect, useState } from 'react';
import styles from './DeviceHealthIcon.module.scss';
import { Icon, Tooltip } from '@mui/material';
import LensIcon from '@mui/icons-material/Lens';
import ErrorIcon from '@mui/icons-material/Error';
import SnoozeIcon from '@mui/icons-material/Snooze';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import LaptopIcon from '@mui/icons-material/Laptop';
import { DeviceHealth } from 'types';

interface DeviceHealthIconProps {
    icon?: DeviceHealth['icon'];
    color?: DeviceHealth['color'];
    tooltip?: DeviceHealth['tooltip'];
}

const DeviceHealthIcon = ({ icon, color, tooltip }: DeviceHealthIconProps) => {
    const [iconElem, setIconElem] = useState<JSX.Element>(<div />);

    useEffect(() => {
        if (icon === 'Lens') setIconElem(<LensIcon data-testid="LensIcon" />);
        else if (icon === 'Snooze')
            setIconElem(<SnoozeIcon data-testid="SnoozeIcon" />);
        else if (icon === 'Laptop' || icon === 'computer')
            setIconElem(<LaptopIcon data-testid="LaptopIcon" />);
        else if (icon === 'CloudOff')
            setIconElem(<CloudOffIcon data-testid="CloudOffIcon" />);
        else setIconElem(<ErrorIcon data-testid="ErrorIcon" />);
    }, [icon]);

    return (
        <div className={styles.DeviceHealthIcon} data-testid="DeviceHealthIcon">
            <Tooltip title={tooltip}>
                <Icon sx={{ color }}>{iconElem}</Icon>
            </Tooltip>
        </div>
    );
};

export default DeviceHealthIcon;
